import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;


export const getTeacherAllocationListSvc = (callback) => {
    // console.log("getTeacherAllocationListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation/teacher/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getTeacherAllocationListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchAllocation = response.data.lstTeacher;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const handoverTeacherSvc = (fromTchId, toTchId, callback) => {
    // console.log("handoverTeacherSvc called, fromTchId",fromTchId, ", toTchId", toTchId);
    const formData = new FormData();
    formData.append("fromTchId", fromTchId)
    formData.append("toTchId", toTchId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/handover/save',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in handoverTeacherSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
